/**
 * AdminSidebar.js — Account dashboard sidebar navigation.
 *
 * Renders the left-hand navigation links shared by all admin dashboard pages.
 * Highlights the active route and provides a logout action that clears
 * all session data from localStorage.
 *
 * Props:
 *  - useLoggedIn {boolean}       Whether the user is authenticated.
 *  - loggedInUserData {object}   Logged-in user details (used for logout cleanup).
 */

// ─── External libraries ───────────────────────────────────────────────────────
import { ListGroup } from 'react-bootstrap';
import {
    ShareIcon
} from "../../../icons";
import { Link, useLocation } from 'react-router-dom';
import ProfileSvg from "../../../images/profile-dash.svg";
import ProgramSvg from "../../../images/program-dash.svg";
import LibrarySvg from "../../../images/library.svg";
import CpdSvg from "../../../images/cpd.svg";
import BookmarksSvg from "../../../images/Bookmarks.svg";
import BillingSvg from "../../../images/Billing.svg";
import LogoutSvg from "../../../images/Log-out.svg";


export const AdminSidebar = (props) => {
    const location = useLocation();
    return (
        <ListGroup as="ul" className="admin_listing_block list-group position-sticky top-0">
            <ListGroup.Item as="li" className={"admin-profile" === location.pathname.replace('/', '') ? 'active' : null}><Link to="/admin-profile" className="link-item"><img src={ProfileSvg} alt="" />My Profile</Link></ListGroup.Item>
            <ListGroup.Item as="li" className={"admin-my-events" === location.pathname.replace('/', '') ? 'active' : null}><Link to="/admin-my-events" className="link-item"><img src={ProgramSvg} alt="" /> Upcoming Events</Link></ListGroup.Item>
            <ListGroup.Item as="li" className={"admin-my-library" === location.pathname.replace('/', '') ? 'active' : null}><Link to="/admin-my-library" className="link-item"><img src={LibrarySvg} alt="" /> My Digital Library</Link></ListGroup.Item>
            <ListGroup.Item as="li" className={"admin-cpd-points" === location.pathname.replace('/', '') ? 'active' : null}><Link to="/admin-cpd-points" className="link-item"><img src={CpdSvg} alt="" /> CPD Points</Link></ListGroup.Item>
            <ListGroup.Item as="li" className={"my-wishlist" === location.pathname.replace('/', '') ? 'active' : null}><Link to="/my-wishlist" className="link-item"><img src={BookmarksSvg} alt="" /> Bookmarks</Link></ListGroup.Item>
            <ListGroup.Item as="li" className={"admin-orders" === location.pathname.replace('/', '') ? 'active' : null}><Link to="/admin-orders" className="link-item"><img src={BillingSvg} alt="" /> Billing History</Link></ListGroup.Item>
            <ListGroup.Item as="li" className={"refer-earn" === location.pathname.replace('/', '') ? 'd-none active' : 'd-none'}><Link to="/refer-earn" className="link-item"><ShareIcon /> Invite & Earn</Link></ListGroup.Item>
            <ListGroup.Item as="li"><a onClick={() => props.doLogout()} className="link-item"><img src={LogoutSvg} alt="" /> Logout</a></ListGroup.Item>
        </ListGroup>
    )
}